export default __webpack_public_path__ + "static/immersive_game-782f17498670cc5a75af71c65d3c5ccc.webp";